<template>
<div class="col-sm-3 left-col-text wow fadeInRight">
  <div class="list-group">

    <router-link
      v-if="isInfoCategory || isNotCategory"
      :to="{ path: '/posts/', query: { category: 'info-all' }}"
      :class="{ active: checkMatchCategory('info-all') }"
      class="list-group-item"
    >お知らせ一覧</router-link>

  	<a
      v-if="isActivityCategory || isNotCategory"
      href="/pages/?id=activity"
      class="list-group-item"
    >組合員活動とは</a>

    <router-link
      v-if="isActivityCategory || isNotCategory"
      :to="{ path: '/posts/', query: { category: 'activity' }}"
      :class="{ active: checkMatchCategory('activity') }"
      class="list-group-item"
    >組合員活動一覧</router-link>

    <router-link
      v-if="isActivityCategory || isNotCategory"
      :to="{ path: '/posts/', query: { category: 'entry' }}"
      :class="{ active: checkMatchCategory('entry') }"
      class="list-group-item"
    >参加募集一覧</router-link>

    <router-link
      v-if="isActivityCategory || isNotCategory"
      :to="{ path: '/posts/', query: { category: 'report' }}"
      :class="{ active: checkMatchCategory('report') }"
      class="list-group-item"
    >活動レポート一覧</router-link>

    <a href="/news/" class="list-group-item">過去のニュース一覧</a>

  </div>
</div>
</template>
<script>
import arr from '@/util/arr'
import config from '@/config/config'

export default {
  name: 'SideMenu',

  components: {
  },

  props: {
    categorySlug: {
      type: String,
      default: '',
    },

    category: {
      type: Object,
      default: null,
    },
  },

  data(){
    return {
    }
  },

  computed: {
    currentCateSlug() {
      if (this.category != null) return this.category.slug
      if (this.categorySlug) return this.categorySlug
    },

    isInfoCategory() {
      return this.infoCategorySlugs.includes(this.currentCateSlug)
    },

    isActivityCategory() {
      return this.activityCategorySlugs.includes(this.currentCateSlug)
    },

    isNotCategory() {
      return !this.isActivityCategory && !this.isInfoCategory
    },

    parentCateSlugs() {
      if (!this.category) return []
      const cateSlugs = arr.getValsFromNestedObjList(this.category.parents, 'slug', 'parents')
      return cateSlugs
    },
  },

  watch: {
  },

  created() {
  },

  methods: {
    checkMatchCategory(targetCateSlug) {
      if (this.currentCateSlug === targetCateSlug) return true
      if (targetCateSlug === 'info-all') {
        if (this.parentCateSlugs.includes(targetCateSlug)) return true
        if (this.infoCategorySlugs.includes(this.currentCateSlug)) return true
      }
      return false
    },
  },
}
</script>
